header.cancelling_billing {
  display: flex;
  align-items: center;

  position: absolute;
  left: 1em;
  top: 2em;
  right: 1em;
}
